const ITEMS = [
  "Bespoke cardboard tubes",
  "Ø40 — Ø147 mm internal",
  "Pantone® colour match",
  "CMYK litho print",
  "Hot foil stamping",
  "Spot UV coating",
  "MOQ 250 units",
  "Dispatch from 3 weeks",
];

export const Marquee = () => (
  <div className="relative py-7 border-y border-amber-500/12 bg-[#0B0D10] overflow-hidden" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center">
              <span className="font-serif-display italic text-lg sm:text-xl text-[#D9A76A]/80 px-6 whitespace-nowrap">{item}</span>
              <span className="text-[#D4AF37]/50 text-xs">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
